import { useTranslate } from "@tolgee/react";
import { isNil } from "lodash-es";
import React from "react";
import { FilterChipBoolean } from "../../commons/filters/FilterChip.js";
import { ItemBindingChips } from "./fields/ItemBindingChips.js";
import { ItemTypeChips } from "./fields/ItemTypeChips.js";
import type { ItemsSearchFilters } from "./hooks/useItemsSearch.js";
import { Link, Stack, type StackProps, Typography } from "@mui/material";

interface Props {
  filters: ItemsSearchFilters;
  setFilters: React.Dispatch<React.SetStateAction<ItemsSearchFilters>>;
  onReset?(): void;
}

export const ItemSearchChips = ({
  filters,
  setFilters,
  onReset,
  ...props
}: Props & StackProps) => {
  const { t } = useTranslate(["QuoteItem", "QuoteEdit", "Global"]);
  if (
    !filters.type?.length &&
    !filters.binding?.length &&
    isNil(filters.needsAgreement)
  ) {
    return null;
  }
  return (
    <Stack
      direction="row"
      spacing={1}
      flexWrap="wrap"
      useFlexGap
      alignItems="center"
      {...props}
    >
      <ItemTypeChips
        value={filters.type}
        setValue={value => {
          setFilters(f => ({
            ...f,
            type: value && value.length > 0 ? value : undefined,
          }));
        }}
      />
      <ItemBindingChips
        value={filters.binding}
        setValue={value => {
          setFilters(f => ({
            ...f,
            binding: value && value.length > 0 ? value : undefined,
          }));
        }}
      />
      {!isNil(filters.needsAgreement) && (
        <FilterChipBoolean
          label={t("Change", { ns: "QuoteEdit" })}
          value={filters.needsAgreement}
          setValue={value =>
            setFilters(filters => ({
              ...filters,
              needsAgreement: value,
            }))
          }
        />
      )}
      {onReset && (
        <Typography variant="body2">
          <Link onClick={onReset} color="secondary" sx={{ cursor: "pointer" }}>
            {t("Clear all", { ns: "Global" })}
          </Link>
        </Typography>
      )}
    </Stack>
  );
};
